import React, { useEffect, useState } from 'react'
import { aedLogoStyle, eFormButtonsContainer, eformTerms, getDirhamImage, iconContainer, showIconsContainer, termsTitle } from '../../common/cssclasses'
import { useTranslate } from '../../components/TranslationText'
import ShowEntryHorseCard from '../../components/showEntry/ShowEntryHorseCard';
import CustomPopUp from '../../components/CustomPopUp';
import NetaqInput from '../../components/NetaqInput';
import SubmitServiceBtn from '../../components/servicesButtons/SubmitServiceBtn';
import EahsForm from '../../components/EahsForm';
import { createShowEntry, getShowEntryHorses } from './apis/CreateShowEntry';
import { useLocation } from 'react-router';
import axiosInstance from '../../axios/axios';
import ApproveAndPayLaterBtn from '../../components/servicesButtons/ApproveAndPayLaterBtn';

export default function ShowEntryCheckoutPage({ toast }) {
    const UMBRACOURL = process.env.REACT_APP_UMBRACO;
    const BaseURL = process.env.REACT_APP_BASE_URL;
    const { translate } = useTranslate();
    const userId = localStorage.getItem('currentSubAccountId') ?? '';
    const lang = localStorage.getItem('eahsLang') ?? 'en';
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const showId = searchParams.has("showId")
        ? searchParams.get("showId")
        : "";
    const showNameEn = searchParams.has("showNameEn")
        ? searchParams.get("showNameEn")
        : "";
    const showNameAr = searchParams.has("showNameAr")
        ? searchParams.get("showNameAr")
        : "";

    const [horsesList, setHorseList] = useState([]);
    const [checkBox, setCheckBox] = useState([]);
    const [showTerms, setShowTerms] = useState([]);
    const [showDetails, setShowDetails] = useState({});

    async function getShowDetails(id) {
        try {
            const res = await axiosInstance.get(`/showentry/getshowentrybyid?id=${id}&Langauge=${lang}`);
            if (res.status == 200) {
                setShowDetails(res?.data?.result ?? {});
            }
        } catch (error) {
            console.error('error in getting show details', error);
        }
    }

    async function getShowTerms() {
        try {
            const res = await axiosInstance.get(`/ShowEntry/GetShowTerms?showId=${showId}`)
            if (res.status == 200) {
                if (res.data.responseCode == "200") {
                    setShowTerms(res?.data?.result)
                    setCheckBox(res?.data?.result.map((term, index) => ({
                        index: index,
                        termid: term.id,
                        checked: false
                    })))
                }
            }
        } catch (error) {

        }

    }

    const handleCheckboxChange = (termid) => {
        setCheckBox((prev) =>
            prev.map((item) =>
                item.termid === termid ? { ...item, checked: !item.checked } : item
            )
        );
    };

    useEffect(() => {
        if (showId) {
            getShowDetails(showId);
            getShowTerms();
        }
        getShowEntryHorses(userId, showId).then((res) => {
            if (!!res) {
                const horses = res.map((horse, index) => ({
                    isSelected: !!!horse?.statusName ? false : true,
                    name: horse?.horseName,
                    regNr: horse?.horseRegisterNo,
                    ownerName: horse?.ownerName ?? horse?.owner ?? horse.horseOwnerName,
                    origin: horse?.horseOrigin,
                    id: horse?.horseId,
                    status: horse?.statusName,
                    birthDate: horse?.horseBirthDate,
                    birthDateObject: horse?.birthDateObject,
                    isRegisterd: horse?.isRegistered,
                    isEarlyYearlingHorse: horse?.isEarlyYearlingHorse,
                    isQualified: true,
                    amount: horse?.amount,
                    categoryName: horse?.categoryName ?? '',
                    participateWithoutPayment: horse?.participateWithoutPayment ?? false

                }))
                setHorseList(horses);
            }
        }).catch((error) => console.error('error in getting horses' + error))
    }, [])

    const pendingPayment = horsesList.filter(x => x.status == 'PendingPayment');
    const PendingReview = horsesList.filter(x => x.status == 'Draft');
    const totalAmount = pendingPayment.reduce((sum, item) => sum + item.amount, 0);
    const allChecked = checkBox.every(item => item.checked === true);
    const loggedInUser = localStorage.getItem("EAHSUserID");


    function submitHorses(isOnlinePayment = true) {
        if (!allChecked) {
            return;
        }
        const returnUrl = `${BaseURL}/profile?activeTab=participateHistory`;

        const encodeURI = encodeURIComponent(returnUrl);
        createShowEntry('Submit ', [...pendingPayment, ...PendingReview], showId).then((res) => {
            if (res) {
                toast.success(translate('web.savedSuccessfully', 'Saved Successfully'));
                window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${showId}&paymentType=3&userId=${loggedInUser}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment ? "yes" : "no"
                    }&lang=${lang}`
            } else {
                toast.error(translate('web.unexpectedError', 'Unexpected Error'))
            }
        })
    }



    // window.location.href = ;

    return (
        <div className='row rtl'>
            <h2 className={termsTitle}>
                {lang == 'en' ? showNameEn : showNameAr}
            </h2>
            <div className={showIconsContainer}>
                {showDetails?.entryFees != null &&
                    <div className={iconContainer}>
                        <img src={getDirhamImage(lang)} alt='AED' style={aedLogoStyle} />
                        <span>{`${translate("web.showFees", "Show Fees")} ${(showDetails?.entryFees ?? 0).toLocaleString('en-US')} ${translate('web.aed', 'AED')}`}</span>
                    </div>
                }
                <div className={iconContainer}>
                    <i className=" fa-solid fa-chess-knight C89C66" />
                    <span>{`${translate('web.selectedHorses', 'Selected Horses')} ${pendingPayment.length + PendingReview.length}`}</span>
                </div>
            </div>
            {pendingPayment.length > 0 && <>
                <h3 className='fw-bold'>
                    {translate('web.totalToPay', 'Total to Pay')} ({pendingPayment.length})
                </h3>
                {pendingPayment.map((horse, index) => (

                    <div className='col-md-3 col-sm-6 col-12'>
                        <ShowEntryHorseCard key={`horse${index}`} showId={'12313123'} horse={horse} onClick={() => { }} isSelectedTab={true} />
                    </div>
                ))}
            </>}
            {PendingReview.length > 0 && <>
                <h3 className='fw-bold'>
                    {translate('web.pendingConfirmation', 'Pending Confirmation')} ({PendingReview.length})
                </h3>
                {PendingReview.map((horse, index) => (
                    <div className='col-md-3 col-sm-6 col-12'>
                        <ShowEntryHorseCard key={`horse${index}`} showId={'12313123'} horse={horse} onClick={() => { }} isSelectedTab={false} />
                    </div>
                ))}
            </>}
            <EahsForm isNoMargin className={'mb-main'}>
                {showTerms.map((term) => (
                    <div className={eformTerms}>
                        <CustomPopUp
                            key={term?.id}
                            trigger={
                                <NetaqInput
                                    key={term?.id + "123"}
                                    type='checkbox'
                                    name='termsAndConditions'
                                    label={term?.fileName}
                                    checked={
                                        checkBox.find((cb) => cb.termid === term.id)?.checked || false
                                    }
                                    onChange={() => handleCheckboxChange(term.id)}
                                />
                            }
                            title={translate('web.termsAndConditions', 'Terms And Conditions')}
                            content={
                                <>
                                    <div dangerouslySetInnerHTML={{ __html: term.termsAndConditions }} />
                                </>
                            }
                        />
                    </div>
                ))}
            </EahsForm>
            <h3 className={'fw-bold mb-main'}>
                {translate('web.total', 'Total')}: {totalAmount} {translate('web.aed', 'AED')}
            </h3>
            <div className={eFormButtonsContainer}>
                <SubmitServiceBtn disabled={!allChecked} onClick={() => submitHorses(true)} key={'submit'} />
                {horsesList.length > 0 && <>
                    {horsesList[0]?.participateWithoutPayment == true &&
                        <ApproveAndPayLaterBtn
                            disabled={!allChecked} onClick={() => submitHorses(false)} text={translate('web.payLater')} key={'submit'} />
                    }
                </>}
            </div>
        </div>
    )
}
